module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2534/img/callout-blobs.svg"